export enum AppContext {
  Editor = 'EDITOR',
  Client = 'CLIENT'
}
